// Vendors
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { goBack } from 'connected-react-router';

// Actions
import {
  linkAppLink,
  linkServiceSuccess,
} from '../../../reducers/agency/linkService/linkServiceActions';

// Components
import { FormActions, FormActionsItem, Trans } from '../../../components';
import SummaryCard from 'texkit/dist/components/Cards/SummaryCard/SummaryCard';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import {
  TxAlert,
  TxAlertType,
  TxButton,
  TxButtonMode,
} from 'texkit-ui/components';

// Helpers
import { scrollToTop, toSentenceCase } from '../../../lib/helpers';

// Styles
import './link-service-confirm.scss';

const TXHHSLinkServiceConfirm = (account) => {
  const dispatch = useDispatch();

  const [submitting, setSubmitting] = useState(false);

  const [error, setError] = useState(false);

  const handleConfirmClick = () => {
    setSubmitting(true);
    dispatch(linkAppLink())
      .then(() => {
        setError(false);
        dispatch(linkServiceSuccess("txhhschip"));
      })
      .catch(() => {
        setError(true);
        scrollToTop();
        setSubmitting(false);
      });
  };

  const items = ["chipCase", "caseNumber"].map((identifier, idx) => {
                    const value = account[identifier];
                    if (!value) return null;
                    return {
                     className: 'word-break',
                     label: <Trans file="Labels" id={`txhhs_${identifier}`} />,
                     value: value || 'N/A',
}});

  return (
    <div className="txhhs-link-service-confirm">
      <h1 className="h2">
        <Trans file="txhhs" id="txhhschip_LinkService_ConfirmTitleDefault" />
      </h1>
      <p>
        <Trans file="txhhs" id="txhhschip_LinkService_ConfirmDescriptionDefault" />
      </p>
      <>
         <SummaryCard>
          <SummaryCard.List
            items={items}
          />
        </SummaryCard>
      </>
      {error && (
        <TxAlert
          type={TxAlertType.Error}
          heading={<Trans file="Errors" id={'Exception_Link_Title'} />}
        >
          <Trans file="Errors" id={'Exception_Link'} />
        </TxAlert>
      )}
      <FormActions>
        <FormActionsItem>
          <ButtonPrimary
            onClick={handleConfirmClick}
            isLoading={submitting}
            loadingContent={
              <Trans file="Labels" id="Linking" fallback="Linking" />
            }
          >
            <Trans
              file="Labels"
              id="txhhschip_LinkItemDesc"
              fallback="Link Item Description"
            />
          </ButtonPrimary>
        </FormActionsItem>
        <FormActionsItem>
          <TxButton
            mode={TxButtonMode.Secondary}
            onClick={() => dispatch(goBack())}
            disabled={submitting}
          >
            <Trans file="Labels" id="Back" fallback="Back" />
          </TxButton>
        </FormActionsItem>
      </FormActions>
    </div>
  );
};

TXHHSLinkServiceConfirm.propTypes = {
  caseNumber: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired
};

export default TXHHSLinkServiceConfirm;
